import { IExample } from "../../../Components/Examples.Types";

import NonScrollableListExample from "./examples/NonScrollableList.Example";
import ScrollableListExample from "./examples/ScrollableList.Example";

export default [
    {
        title: "Scrollable example",
        component: ScrollableListExample,
        code: require("!raw-loader!./examples/ScrollableList.Example.tsx"),
        dependencies: {
            "Data.ts": require("!raw-loader!./examples/Data.ts"),
            "List.Example.css": require("!raw-loader!./examples/List.Example.css")
        }
    },
    {
        title: "Non-scrollable example",
        component: NonScrollableListExample,
        code: require("!raw-loader!./examples/NonScrollableList.Example.tsx"),
        dependencies: {
            "Data.ts": require("!raw-loader!./examples/Data.ts")
        }
    }
] as IExample[];
